import MModal from "./MModal.vue";
export default MModal;
